<template>
    <div>
        <add-new-form-modal ref="formModal"/>
    </div>
</template>
<script>
import AddNewFormModal from '../../../modules/SpaceForms/organisms/AddNewFormModal.vue';
export default {
    name: "CreateForm",
    components: {
        AddNewFormModal
    },
    methods: {
        init() {
            this.$refs.formModal.open();
        }
    },
}
</script>
